import { useEffect } from "react";
import { useBranch } from "../../../hooks/branches/useBranch";
import { useCashRegister } from "../../../hooks/cash/useCashRegister";

import FormModal from "../../Modals/FormModal";
import CashRegisterForm from "./CashRegisterForm";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CashRegisterCreatePopup = ({ isOpen, onClose }: Props) => {

  const { createRegister } = useCashRegister();
  const { branchDropdown, fetchBranchDropdown } = useBranch();

  useEffect(() => {
    if (isOpen) {
      fetchBranchDropdown();
    }
  }, [isOpen]);

  const handleSubmit = async (data: any) => {
    await createRegister(data);
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Registrar Terminal POS"
      maxWidth="max-w-3xl"
      overlayBg="black"
      zIndex="front"
    >
      <CashRegisterForm
        onSubmit={handleSubmit}
        branchOptions={branchDropdown}
      />
    </FormModal>
  );
};

export default CashRegisterCreatePopup;